import React from 'react';
/** Soft teal (top-right) and periwinkle (bottom-left) washes from the brand's social preview. */
export function AmbientWash() {
  return <div aria-hidden="true" className="ambient-wash pointer-events-none fixed inset-0 z-0" data-id="element-14" />;
}